module.exports = __webpack_public_path__ + "img/inktober_2020_15_rough.ce962b3c.jpg";